export default class WsGate {
    constructor(url) {
        this.url = url
        this.packetId = 0
        this.ws = null
    }

    get socket() {
        return this.ws
    }

    connect() {
        if (
            window.wsgate &&
            window.wsgate[this.url] &&
            (window.wsgate[this.url].socket.readyState ===
                WebSocket.CONNECTING ||
                window.wsgate[this.url].socket.readyState === WebSocket.OPEN)
        ) {
            this.ws = window.wsgate[this.url].socket
            return
        }

        this.ws = new window.WebSocket(this.url)
        this.ws.binaryType = 'arraybuffer'

        this.ws.onclose = function () {
            // Reconnect if connection was lost or closed, no matter if was closed widget must show data!
            setTimeout(() => {
                this.connect()
            }, 1000)
        }

        this.ws.onerror = function (error) {
            throw new Error(`WS erros ${error.message}`)
        }

        window.wsgate = {
            [this.url]: this
        }
    }

    sendPacket(type, id, data) {
        const strData = {
            name: 'quotes.' + type,
            id: id + '',
            body: {
                stream: 'real',
                symbols: data
            }
        }

        this.ws.send(JSON.stringify(strData))
    }

    subscribe(symbols) {
        if (this.ws.readyState === WebSocket.CONNECTING) {
            this.ws.addEventListener('open', () => {
                this.sendPacket('subscribe', this.packetId++, symbols)
            })
        } else {
            this.sendPacket('subscribe', this.packetId++, symbols)
        }
    }

    unsubscribe(symbols) {
        if (this.ws.readyState === WebSocket.OPEN) {
            this.sendPacket('unsubscribe', this.packetId++, symbols)
        }
    }

    listen(callback) {
        this.ws.addEventListener('message', event => {
            if (typeof event.data !== 'string') return

            const packet = JSON.parse(event.data)
            const quotes = []

            if (
                packet.name === 'quotes.update' &&
                packet.body &&
                packet.body.result &&
                packet.body.result.quotes
            ) {
                for (let i = 0; i < packet.body.result.quotes.length; i++) {
                    quotes.push(
                        WsGate.convertQuote(packet.body.result.quotes[i])
                    )
                }
            }

            callback(quotes)
        })
    }

    static convertQuote(quote) {
        const precisionFactor = Math.pow(10, -(quote.f & 0xf)) // Flags

        return {
            s: quote.s, // Symbol
            b: quote.b * precisionFactor, // Bid
            a: quote.a * precisionFactor, // Ask
            m: quote.m * precisionFactor, // Mid
            r: (quote.r || quote.m) * precisionFactor, // Rate || Mid
            dt: quote.t * 1000, // Time
            n: quote.n, // Number
            iw: (quote.f & 0x10) > 0,
            om: (quote.f & 0x20) > 0
        }
    }
}
